/* eslint-disable @typescript-eslint/no-unused-vars */
import type { BetButton } from '@svenskaspelab/ui/react/bet-button';
import type { ComponentProps } from 'react';

/**
 * Gets the appropriate button size based on screen size.
 *
 * @param screenSize The screen size identifier (mobile, tablet, desktop)
 * @param screenSize.isMobile Whether the screen size is mobile
 * @param screenSize.isTablet Whether the screen size is tablet
 * @param screenSize.isDesktop Whether the screen size is desktop
 * @returns The button size string (sm, md, lg)
 */
export function getButtonSize({
  isMobile,
  isTablet,
  isDesktop,
}: {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}): ComponentProps<typeof BetButton>['size'] {
  // According to betting UI guidelines, the button size for mobile should be 'sm', for tablet 'md' and for desktop 'lg'. However, due to design changes, we are currently using 'sm' for all screen sizes. The logic is kept in place for future use when other sizes might be needed.
  // const buttonSize: 'sm' | 'md' | 'lg' = isMobile ? 'sm' : isTablet ? 'md' : isDesktop ? 'lg' : 'md';
  const buttonSize = 'sm';
  return buttonSize;
}
